import script from "./MarketNowStub.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketNowStub.vue?vue&type=script&setup=true&lang=js"

import "./MarketNowStub.vue?vue&type=style&index=0&id=5d601cb3&lang=scss"

const __exports__ = script;

export default __exports__